import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../../index';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const Play = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    description,
    dmId = 'dm-play',
    pointerEvents = 'none',
    secondColor,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.play.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={color}
        d="M15.82,11.78l-5.2-3c-0.08-0.04-0.17-0.04-0.25,0C10.29,8.83,10.24,8.91,10.24,9v6c0,0.09,0.05,0.17,0.12,0.22
	c0.04,0.02,0.08,0.03,0.12,0.03s0.09-0.01,0.12-0.03l1.57-0.91c1.27-0.73,2.75-1.59,3.63-2.09c0.08-0.04,0.12-0.13,0.12-0.22
	S15.89,11.83,15.82,11.78z"
      />
      <path
        fill={color}
        d="M12,22C6.49,22,2,17.51,2,12S6.49,2,12,2s10,4.49,10,10S17.51,22,12,22z M12,3.57c-4.65,0-8.43,3.78-8.43,8.43
	s3.78,8.43,8.43,8.43s8.43-3.78,8.43-8.43S16.65,3.57,12,3.57z"
      />
    </IconSvg>
  );
};

export default memo(Play);
